import { useEffect } from 'react'
import { useAuth } from '../auth/AuthProvider'

export default function Login() {
  const { login, user, isLoading } = useAuth()

  useEffect(() => {
    if (!isLoading && !user) {
      login()
    }
  }, [isLoading, user, login])

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <p>Redirecting to login…</p>
    </div>
  )
}
